import { z } from 'zod';
/**
 * Recipe books, and sharing one with another household (ADR-014).
 *
 * A grant is read-only always, so nothing here lets a recipient describe a
 * change: they take a copy instead.
 */
export const recipeBookInputSchema = z.object({
    name: z.string().min(1).max(120),
    description: z.string().max(1000).nullish(),
});
export const recipeBookEntrySchema = z.object({
    recipeId: z.string().uuid(),
    title: z.string(),
    position: z.number().int(),
    servings: z.number().int(),
    energyKcalPerServing: z.number().nullable(),
    /** False for a recipe read through a share: it is not yours to change. */
    mine: z.boolean(),
});
export const recipeBookSchema = z.object({
    id: z.string().uuid(),
    tenantId: z.string().uuid(),
    name: z.string(),
    description: z.string().nullable(),
    position: z.number().int(),
    recipeCount: z.number().int(),
    /** True when this household owns it, false when it arrived by a share. */
    mine: z.boolean(),
    /** Households this book is shared with. Empty for a book shared to you. */
    sharedWith: z.array(z.object({ tenantId: z.string().uuid(), name: z.string() })),
    createdAt: z.date(),
});
export const recipeBookDetailSchema = recipeBookSchema.extend({
    entries: z.array(recipeBookEntrySchema),
});
export const bookRecipeInputSchema = z.object({ recipeId: z.string().uuid() });
/** Whole-list reorder: the ids in the order they should now appear. */
export const reorderBookInputSchema = z.object({
    recipeIds: z.array(z.string().uuid()).max(500),
});
export const bookInviteSchema = z.object({
    /** Shown once, never stored: only its hash is kept. */
    token: z.string(),
    expiresAt: z.date(),
});
export const redeemBookInviteSchema = z.object({ token: z.string().min(16).max(200) });
//# sourceMappingURL=recipe-book.js.map